import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  index() {
    return axios.get(`${window.api_url}/organization/report_data_types`).catch(handleError);
  },
};
